import { Button, Card, Input, List, Popover } from 'antd';
import 'lazysizes';
import Link from 'next/link';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { JsonLd } from 'react-schemaorg';
import { listTemplateCategoriesDisplaymmUnit } from '../HomePageContainer/constants';
import Icon from '~/components/icon';
import MetaFacebook from '~/components/SharingMeta/FacebookMeta';
import MetaTwitter from '~/components/SharingMeta/TwitterMeta';
import Config from '~/config';
import withi18next from '~/hocs/withi18next';
import { getLargeThumbnailURL } from '~/utils/canvasUtils/getLargeThumbnailURL';
import { getLargeThumbnailURLsOfPages } from '~/utils/canvasUtils/getLargeThumbnailURLsOfPages';
import { getSmallThumbnailURL } from '~/utils/canvasUtils/getSmallThumbnailURL';
import { getSmallThumbnailURLsOfPages } from '~/utils/canvasUtils/getSmallThumbnailURLsOfPages';
import { convertPixelToOtherUnit } from '~/utils/canvasUtils/convertPixelToOtherUnit';
import { editURLInBrowser } from '~/utils/mainHelpers/editURLInBrowser';
import { openURL } from '~/utils/mainHelpers/openURL';
import localeHelpers from '~/utils/localeHelpers';
import dataHelpers from '~/utils/dataHelpers';

@withi18next()
class TemplatePreviewContent extends React.Component {
  state = {
    sharePopoverVisible: false,
    copySuccess: false,
    templateDetail: {},
    currentPreviewImage: null,
    currentPreviewIndex: 1,
    currentPreviewTags: [],
  };

  // async componentDidMount() {
  //   Router.prefetch('/edit');
  // }

  async componentDidUpdate() {
    const { isModal } = this.props;
    if (isModal) {
      const scrollTop = document.getElementsByClassName('ant-modal')[0];
      if (scrollTop) scrollTop.scrollIntoView();
    }
  }

  setShareOverVisible = (sharePopoverVisible) => {
    this.setState({ sharePopoverVisible });
  };

  handleEditTemplate = (item) => {
    const { i18n } = this.props;
    openURL(`/design/${item.id}`, '_blank');
  };

  handleOpenEditPage = (item) => {
    const { i18n } = this.props;
    openURL('/design/new-blank', '_blank');
  };

  handleSeeMore = (catSlug) => {
    const { i18n } = this.props;
    openURL(`/free-template/${catSlug}`, '_blank');
  };

  render() {
    const {
      t,
      i18n,
      handleOpenTemplatePreviewModal,
      selectedTemplate,
      currentTemplateTags,
      setSelectedTemplate,
      isLoadingTemplates,
      isPage,
      isHomepage,
      isSearchPage,
      isModal,
      catNameByLang,
    } = this.props;
    let { templates, catSlug } = this.props;
    let {
      sharePopoverVisible,
      copySuccess,
      currentPreviewTags,
      currentPreviewImage,
      currentPreviewIndex,
    } = this.state;
    if (templates[0] && templates[0].isNewItem) {
      templates.shift();
    }
    templates = [...templates].filter((item) => {
      return item.id !== selectedTemplate.id;
    });
    if (isHomepage || isModal) {
      templates = templates.splice(0, 16);
    }
    let currentLang = i18n.language;

    let sharingURL = `${Config.redirectURL}/${currentLang}/free-template/${catSlug}-template-${selectedTemplate.id}`;
    const tagLang = localeHelpers.convertToDataLanguage(currentLang);

    let previewURL;

    if (selectedTemplate.num_pages > 1) {
      previewURL = getLargeThumbnailURL(
        currentPreviewImage || selectedTemplate.thumbnail_url,
        'template',
      );
    } else {
      previewURL = getLargeThumbnailURL(
        selectedTemplate.thumbnail_url,
        'template',
      );
    }
    let smallThumbnailURLs = [];
    let largeThumbnailURLs = [];
    if (selectedTemplate.num_pages > 1) {
      smallThumbnailURLs = getSmallThumbnailURLsOfPages(
        selectedTemplate.thumbnail_url,
        '',
        null,
        selectedTemplate.num_pages,
      );
      largeThumbnailURLs = getLargeThumbnailURLsOfPages(
        selectedTemplate.thumbnail_url,
        '',
        selectedTemplate.num_pages,
      );
    }

    const responsive = {
      superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 7,
      },
      largerDesktop: {
        breakpoint: { max: 3000, min: 2000 },
        items: 7,
      },
      desktop: {
        breakpoint: { max: 2000, min: 1125 },
        items: 5,
      },
      tablet: {
        breakpoint: { max: 1125, min: 0 },
        items: 3,
      },
    };

    // Build title
    const titleText =
      selectedTemplate.title ||
      t('ace-template-default-title-text', {
        categoryName: catNameByLang,
        templateID: selectedTemplate.id,
      });

    // Build tags
    const tagNames = dataHelpers.buildTagNames(currentTemplateTags);

    const imageAltText = t('ace-template-thumbnail-alt-text', {
      templateTitle: titleText,
      tagNames: tagNames || catNameByLang,
      categoryName: catNameByLang,
    });
    const imageTitleText = t('ace-template-thumbnail-title-text', {
      templateTitle: titleText,
      categoryName: catNameByLang,
    });

    const isDisplaymmUnit = listTemplateCategoriesDisplaymmUnit.includes(
      selectedTemplate?.category?.id,
    );

    return (
      <div
        style={{
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <MetaTwitter
          url={sharingURL}
          title={selectedTemplate.title}
          description={selectedTemplate.title}
          image={previewURL.socialShare}
        />
        <MetaFacebook
          url={sharingURL}
          title={selectedTemplate.title}
          description={selectedTemplate.title}
          image={previewURL.socialShare}
          t={t}
        />
        <div style={{ width: '100%', padding: isPage ? 30 : 0 }}>
          <div className="template-preview-modal">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                width: '80%',
              }}
              className="template-preview-modal-left-content"
            >
              <div
                style={{
                  width: '100%',
                  height: 620,
                  textAlign: 'center',
                  marginBottom: 20,
                  backgroundColor: 'rgba(8,25,43,0.03)',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  padding: 10,
                }}
                className="template-preview-modal-left-content-image"
              >
                <picture>
                  {previewURL.sources.map((srcItem, key) => (
                    <source
                      key={key}
                      srcSet={srcItem.srcset}
                      media={srcItem.media}
                    ></source>
                  ))}
                  <img
                    alt={imageAltText}
                    title={imageTitleText}
                    src={currentPreviewImage || previewURL.img.src}
                    srcSet={currentPreviewImage || previewURL.img.srcset}
                    loading="eager"
                    decoding="sync"
                    className="preview-image detail"
                    style={
                      selectedTemplate.width > selectedTemplate.height
                        ? { width: '100%', height: 'auto' }
                        : { width: 'auto', height: '100%' }
                    }
                  />
                </picture>
              </div>
              {selectedTemplate.num_pages > 1 && (
                <>
                  <div>
                    {`${t('ace-text-page', { index: currentPreviewIndex })} / ${
                      selectedTemplate.num_pages
                    }`}
                  </div>
                  <Carousel
                    ssr
                    infinite={false}
                    responsive={responsive}
                    deviceType={'desktop'}
                    itemClass="carousel-image-item"
                  >
                    {smallThumbnailURLs.map((thumbnailURL, idx) => {
                      return (
                        <div style={{ width: 120 }} key={`${idx}`}>
                          <Card
                            hoverable
                            bodyStyle={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'center',
                              height: 120,
                              width: 120,
                              padding: 10,
                            }}
                            onClick={() => {
                              this.setState({
                                currentPreviewImage: largeThumbnailURLs[idx],
                                currentPreviewIndex: idx + 1,
                              });
                            }}
                            style={{
                              overflow: 'hidden',
                              backgroundColor: 'rgb(237, 240, 242)',
                              border:
                                currentPreviewImage === largeThumbnailURLs[idx]
                                  ? '2px solid black'
                                  : '2px solid rgba(64, 87, 109, 0.07)',
                              borderRadius: '4px',
                            }}
                          >
                            <img
                              data-src={thumbnailURL}
                              loading="lazy"
                              width={selectedTemplate.width}
                              height={selectedTemplate.height}
                              className="preview-image lazyload"
                              style={
                                selectedTemplate.width > selectedTemplate.height
                                  ? { width: 100, height: 'auto' }
                                  : { width: 'auto', height: 100 }
                              }
                            />
                          </Card>
                        </div>
                      );
                    })}
                  </Carousel>
                </>
              )}
            </div>
            <div className="template-description-container">
              <h1 style={{ fontSize: 30 }}>{titleText}</h1>
              <Button
                style={{
                  marginTop: 10,
                  height: 40,
                  color: 'white',
                  backgroundColor: '#038489',
                  fontWeight: 500,
                  width: '100%',
                }}
                onClick={async () => {
                  await this.handleEditTemplate(selectedTemplate);
                }}
              >
                {t('ace-edit-this-template')}
              </Button>

              <br />

              <Popover
                content={
                  <div>
                    <Input
                      id={`template-sharing-url-${selectedTemplate.id}`}
                      value={sharingURL}
                      editable="false"
                      style={{
                        width: 235,
                        height: 35,
                        marginBottom: 5,
                        marginRight: 5,
                      }}
                    />
                    <Button
                      style={{
                        height: 35,
                      }}
                      onClick={() => {
                        let copyTextarea = document.querySelector(
                          `#template-sharing-url-${selectedTemplate.id}`,
                        );
                        copyTextarea.focus();
                        copyTextarea.select();
                        try {
                          let copySuccess = document.execCommand('copy');
                          this.setState({ copySuccess });
                        } catch (err) {
                          console.log(err);
                        }
                      }}
                    >
                      {copySuccess ? (
                        <Icon
                          name="check"
                          prefix="fas"
                          style={{ marginRight: 5, color: 'green' }}
                        />
                      ) : (
                        <Icon
                          name="copy"
                          prefix="far"
                          style={{ marginRight: 5 }}
                        />
                      )}
                      {t('ace-button-copy')}
                    </Button>
                    <br />
                    <Button
                      style={{
                        backgroundColor: '#3b5998',
                        color: '#fff',
                        height: 35,
                      }}
                      onClick={() => {
                        let url = `https://www.facebook.com/dialog/share?app_id=117289276958719&display=popup&href=${sharingURL}`;
                        window.open(url, '_blank');
                      }}
                    >
                      <Icon
                        name="facebook-f"
                        prefix="fab"
                        style={{ marginRight: 5 }}
                      />
                      Facebook
                    </Button>
                    <Button
                      style={{
                        marginLeft: 5,
                        backgroundColor: '#FFF',
                        color: '#000',
                        height: 35,
                      }}
                      onClick={() => {
                        let url = `https://x.com/intent/tweet?url=${sharingURL}&hashtags=デザインAC`;
                        window.open(url, '_blank');
                      }}
                    >
                      <img
                        src="/static/twitter.svg"
                        style={{ width: 16, marginRight: 5 }}
                        alt="X"
                      />
                      X
                    </Button>
                    <Button
                      style={{
                        marginLeft: 5,
                        backgroundColor: '#be1e24',
                        color: '#fff',
                        height: 35,
                      }}
                      onClick={() => {
                        let url = `https://pinterest.com/pin/create/button/?url=${sharingURL}&media=${previewURL}`;
                        window.open(url, '_blank');
                      }}
                    >
                      <Icon
                        name="pinterest-p"
                        prefix="fab"
                        style={{ marginRight: 5 }}
                      />
                      Pinterest
                    </Button>
                  </div>
                }
                trigger="click"
                placement="bottom"
                visible={sharePopoverVisible}
                onVisibleChange={this.setShareOverVisible}
              >
                <Button
                  style={{
                    marginTop: 10,
                    height: 40,
                    fontWeight: 500,
                    width: '100%',
                  }}
                  onClick={() => {}}
                >
                  {t('ace-button-share-sns')}
                </Button>
              </Popover>
              <p style={{ marginTop: 10 }}>
                <span>
                  {t('ac-text-size')}:
                  {convertPixelToOtherUnit(
                    selectedTemplate.width,
                    isDisplaymmUnit
                      ? 'mm'
                      : selectedTemplate.workarea_unit || 'px',
                  )}
                  x
                  {convertPixelToOtherUnit(
                    selectedTemplate.height,
                    isDisplaymmUnit
                      ? 'mm'
                      : selectedTemplate.workarea_unit || 'px',
                  )}
                  {isDisplaymmUnit
                    ? 'mm'
                    : selectedTemplate.workarea_unit || 'px'}
                </span>
                <br />
                <span>
                  {t('ace-category')}:{' '}
                  {selectedTemplate.categories?.length ? (
                    selectedTemplate.categories.map((item, index) => {
                      let cateNames = '';
                      try {
                        cateNames = JSON.parse(item.name);
                      } catch (err) {
                        cateNames = item.name;
                      }
                      const catName =
                        cateNames[`cat_name_${tagLang}`] ||
                        cateNames[`cat_name_original`];
                      return (
                        <span key={item.id}>
                          <Link
                            href={`/free-template/${item.cat_slug}`}
                            passHref
                            prefetch={false}
                          >
                            <a>{catName}</a>
                          </Link>
                          {index < selectedTemplate.categories.length - 1 &&
                            '   '}
                        </span>
                      );
                    })
                  ) : (
                    <Link
                      href={`/free-template/${catSlug}`}
                      passHref
                      prefetch={false}
                    >
                      <a>{catNameByLang}</a>
                    </Link>
                  )}
                </span>
              </p>
              {currentPreviewTags.length === 0 &&
                currentTemplateTags &&
                currentTemplateTags.length > 0 && (
                  <div className="template-detail-tags">
                    {currentTemplateTags.map((tag) => {
                      let tagNames = tag.name;
                      try {
                        tagNames = JSON.parse(tag.name);
                      } catch (err) {
                        tagNames = tag.name;
                      }
                      const tagContent =
                        tagNames[`name_${tagLang}`] ||
                        tagNames[`name_original`];
                      if (!tagContent) return null;

                      return (
                        <Button
                          className="template-detail-tag"
                          key={tag.id}
                          style={{ margin: 2 }}
                        >
                          <a
                            href={`/${
                              i18n.language === 'ja' ? '' : `${i18n.language}/`
                            }templates/search?keyword=${tagContent}`}
                          >
                            {tagContent}
                          </a>
                        </Button>
                      );
                    })}
                  </div>
                )}
              {currentPreviewTags.length > 0 && (
                <div className="template-detail-tags">
                  {currentPreviewTags.map((tag) => {
                    let tagNames = tag.name;
                    try {
                      tagNames = JSON.parse(tag.name);
                    } catch (err) {
                      tagNames = tag.name;
                    }
                    const tagContent =
                      tagNames[`name_${tagLang}`] || tagNames[`name_original`];
                    if (!tagContent) return null;

                    return (
                      <Button
                        className="template-detail-tag"
                        key={tag.id}
                        style={{ margin: 2 }}
                      >
                        <a
                          href={`/${
                            i18n.language === 'ja' ? '' : `${i18n.language}/`
                          }templates/search?keyword=${tagContent}`}
                        >
                          {tagContent}
                        </a>
                      </Button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
          <h2 style={{ fontSize: 14, fontWeight: 500, margin: '10px 0' }}>
            {t('ace-text-similar-templates')}
          </h2>
          <List
            loading={isLoadingTemplates}
            grid={{
              gutter: 10,
              xs: 2,
              sm: 2,
              md: 4,
              lg: 4,
              xl: 4,
              xxl: 8,
            }}
            dataSource={templates}
            renderItem={(item) => {
              const { title, tags } = item;
              // Build title
              const titleText =
                title ||
                t('ace-template-default-title-text', {
                  categoryName: catNameByLang,
                  templateID: item.id,
                });
              // Build tags
              const tagNames = dataHelpers.buildTagNames(tags);

              const imageAltText = t('ace-template-thumbnail-alt-text', {
                templateTitle: titleText,
                tagNames: tagNames || catNameByLang,
                categoryName: catNameByLang,
              });
              const imageTitleText = t('ace-template-thumbnail-title-text', {
                templateTitle: titleText,
                categoryName: catNameByLang,
              });
              const smallThumbnailUrl = getSmallThumbnailURL(
                item.thumbnail_url,
              );
              return (
                <List.Item>
                  <Card
                    onClick={async () => {
                      setSelectedTemplate({
                        id: item.id,
                        title: item.title,
                        height: item.height,
                        width: item.width,
                        thumbnail_url: item.thumbnail_url,
                        workarea_unit: item.workarea_unit,
                        num_pages: item.num_pages,
                        tags: item.tags,
                        category: item.category,
                        categories: item.categories,
                      });
                      this.setState({
                        currentPreviewTags: item.tags || [],
                        currentPreviewImage: null,
                      });

                      handleOpenTemplatePreviewModal(true);
                      editURLInBrowser(
                        `/free-template/${catSlug}-template-${item.id}`,
                      );
                      this.setState({ copySuccess: false });
                      if (isModal) {
                        const scrollTop = document.getElementById(
                          'template-preview-scroll-top',
                        );
                        if (scrollTop) scrollTop.scrollIntoView();
                      }
                    }}
                    hoverable
                    bodyStyle={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 250,
                      width: '100%',
                      padding: 10,
                    }}
                    style={{
                      overflow: 'hidden',
                      backgroundColor: 'rgb(237, 240, 242)',
                      border: '1px solid rgba(64, 87, 109, 0.07)',
                      borderRadius: '4px',
                    }}
                  >
                    <figure className="image-figure">
                      <a
                        className="image-figure"
                        href={`/free-template/${catSlug}-template-${item.id}`}
                        onClick={(e) => e.preventDefault()}
                      >
                        <img
                          alt={imageAltText}
                          title={imageTitleText}
                          data-src={smallThumbnailUrl}
                          loading="lazy"
                          className="template-preview-image lazyload"
                          width={item.width}
                          height={item.height}
                          style={
                            item.width > item.height
                              ? { width: '100%', height: 'auto' }
                              : { width: 'auto', height: '100%' }
                          }
                        />
                        <div className="image-mask"></div>
                        <figcaption className="image-figcaption">
                          {titleText}
                        </figcaption>
                        <noscript>
                          <img
                            src={smallThumbnailUrl}
                            loading="lazy"
                            alt={imageAltText}
                            title={imageTitleText}
                            width={item.width}
                            height={item.height}
                            style={
                              item.width > item.height
                                ? { width: '100%', height: 'auto' }
                                : { width: 'auto', height: '100%' }
                            }
                          />
                        </noscript>
                        <JsonLd
                          item={{
                            '@context': 'https://schema.org',
                            '@type': 'ImageObject',
                            name: titleText,
                            contentUrl: smallThumbnailUrl,
                            thumbnail: smallThumbnailUrl,
                          }}
                        />
                      </a>
                    </figure>
                  </Card>
                </List.Item>
              );
            }}
          ></List>
          <div
            className="btn-see-more"
            onClick={() => this.handleSeeMore(catSlug)}
          >
            {t('ace-text-see-more')}
          </div>
          <span
            dangerouslySetInnerHTML={{
              __html: t('ace-text-template-detail-description', {
                cat: catNameByLang,
                redirectURL: Config.redirectURL,
              }),
            }}
          />
        </div>
        <style jsx global>
          {`
            .template-preview-modal-left-content-image > div {
              position: relative !important;
              width: ${selectedTemplate.width > selectedTemplate.height
                ? '100%'
                : 'auto'} !important;
              height: ${selectedTemplate.width > selectedTemplate.height
                ? 'auto'
                : '100%'} !important;
            }
            .preview-image.detail {
              position: relative !important;
              width: 100% !important;
              height: 100% !important;
              max-height: 600px !important;
            }
            .carousel-image-item {
              width: 120px !important;
              margin-right: 10px;
              margin-bottom: 10px;
            }
            .image-mask {
              background: linear-gradient(
                to bottom,
                rgba(40, 54, 69, 0) 0%,
                rgba(40, 54, 69, 0.1) 50%,
                rgba(40, 54, 69, 0.7) 100%
              );
              display: block;
              overflow: hidden;
              position: absolute;
              top: 0px;
              left: 0px;
              right: 0px;
              bottom: 0px;
              box-sizing: border-box;
              margin: 0px;
              z-index: 2;
              opacity: 0;
            }

            .image-figcaption {
              display: flex;
              align-items: flex-end;
              overflow: hidden;
              position: absolute;
              top: 0px;
              left: 0px;
              right: 0px;
              bottom: 0px;
              box-sizing: border-box;
              margin: 0px;
              z-index: 3;
              opacity: 0;
              font-weight: bold;
              color: white;
              padding-bottom: 20px;
              padding-left: 10px;
              font-size: 13px;
            }

            .image-figure {
              display: contents;
              overflow: hidden;
              position: absolute;
              top: 0px;
              left: 0px;
              right: 0px;
              bottom: 0px;
              box-sizing: border-box;
              margin: 0px;
              text-align: center;
            }

            .image-figure:hover .image-figcaption {
              opacity: 1;
            }

            .image-figure:hover .image-mask {
              opacity: 1;
            }

            .ant-pagination {
              text-align: center !important;
            }

            .preview-image {
              object-fit: contain;
              max-width: 100%;
              max-height: 100%;
            }

            .template-preview-image {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              filter: drop-shadow(0 0 0.75rem rgba(53, 71, 90, 0.2));
            }

            .lazyload:not([src]) {
              visibility: hidden;
            }

            .template-detail-tag {
              padding: 5px 15px;
              border: #cfd9e0 1px solid;
              font-size: 14px;
            }
            .template-detail-tags {
              margin-top: 10px;
            }
          `}
        </style>
        <style jsx>
          {`
            .btn-see-more {
              font-size: 14px;
              font-weight: 500;
              margin: 5px 0;
              width: 100%;
              text-align: end;
              cursor: pointer;
            }
            .btn-see-more:hover {
              text-decoration: underline;
            }

            .template-preview-modal {
              display: flex;
              flex-direction: row;
            }

            .template-description-container {
              margin-left: 20px;
              width: 400px;
              flex: initial;
            }

            @media only screen and (max-width: 1175px) {
              .template-preview-modal-left-content {
                width: 65% !important;
              }
              .template-description-container {
                width: 35% !important;
              }
            }

            @media only screen and (max-width: 770px) {
              .template-preview-modal-left-content {
                width: 60% !important;
              }
              .template-description-container {
                width: 40% !important;
              }
            }

            @media only screen and (max-width: 600px) {
              .template-preview-modal-left-content {
                width: 100% !important;
              }
              .template-description-container {
                width: 100% !important;
              }
              .template-preview-modal-left-content-image {
                height: auto !important;
              }
            }

            @media only screen and (max-width: 600px) {
              .template-preview-modal {
                display: flex;
                flex-direction: column;
              }
              .template-description-container {
                margin-left: 0px;
                width: 100%;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default TemplatePreviewContent;
